import React from "react";
import { Mail, Phone, Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-background border-t border-white/10 py-12 px-6 md:px-12 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <h2 className="text-2xl font-bold mb-4 animate-gradient-text">
              Ved3D Creations
            </h2>
            <p className="text-muted-foreground max-w-md mb-6">
              Transforming your imagination into tangible art with high-quality
              3D printed products. Custom designs, functional accessories, and
              decorative marvels.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/ved3dcreations/"
                className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
              >
                <Instagram className="h-5 w-5" />
                <span className="text-sm font-medium">
                  Follow us on Instagram
                </span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a
                  href="mailto:ved3dcreations@gmail.com"
                  className="hover:text-primary transition-colors"
                >
                  ved3dcreations@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <a
                  href="tel:8553552031"
                  className="hover:text-primary transition-colors"
                >
                  8553552031
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>
            © {new Date().getFullYear()} Ved3D Creations. All rights reserved.
          </p>
          <p className="font-medium">
            website created by{" "}
            <span className="text-primary">ved3dcreations</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
